// Personnel collapsibles — toggle aria-expanded on click.
// CSS (personnel-collapsibles.scss) handles the height animation via
// grid-template-rows; this script only flips the aria-expanded state.
// Multiple items can be open simultaneously (no mutex).
(function () {
    'use strict';

    function ready() {
        document.querySelectorAll('[data-personnel-collapsibles-toggle]').forEach(function (button) {
            button.addEventListener('click', function () {
                var expanded = button.getAttribute('aria-expanded') === 'true';
                button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
            });
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', ready);
    } else {
        ready();
    }
})();
